// An unconfigured scope may be inspected, but must never become editable implicitly.
export function checklistScopeView(questions) {
  const scoped = questions.filter((question) => (question.isInReviewScope ?? question.isInScope) !== false);
  return {
    questions: scoped.length ? scoped : questions,
    preview: questions.length > 0 && scoped.length === 0,
  };
}
